import { MEDIA_BASE_URL } from "../../settings";

/**
 * NSW Design System masterbrand header with a descriptor.
 * https://designsystem.nsw.gov.au/components/header/index.html
 *
 * The design system's header also offers menu and search affordances. This
 * site has neither a navigation tree nor a search index, so those buttons are
 * omitted rather than rendered as controls that do nothing.
 *
 * The waratah lockup is served as a static asset rather than inlined: the
 * design system ships it as markup inside its own templates, not as a file in
 * the npm package, so a copy lives in public/img alongside the other imagery.
 */
const NswSiteHeader = () => (
  <header className="nsw-header">
    <div className="nsw-header__container">
      <div className="nsw-header__inner">
        <div className="nsw-header__main">
          <div className="nsw-header__waratah">
            <a href="https://www.nsw.gov.au/education-and-training/nesa">
              <img
                src={MEDIA_BASE_URL + "/img/nsw-waratah.svg"}
                alt="NSW Government"
                height="50"
              />
            </a>
          </div>
          <div className="nsw-header__name">
            <div className="nsw-header__title">NSW Education Standards Authority</div>
          </div>
        </div>
      </div>
    </div>
  </header>
);

export default NswSiteHeader;
